import { useSelector } from 'react-redux'
import EventEmitter, { SHOW_POPUP_UPGRADE } from '../../../helpers/EventEmitter'
import { FORMAT, formatDateTime } from '../../../helpers/datetime'
import { selectUserType } from '../../../layout/store/slice'
import { USER_TYPE } from '../../../utils/authorization'

export const LastUpdateDate = ({ rawData, locale, timezone }) => {
  const userType = useSelector(selectUserType)

  const disableNeedUpgrade = [USER_TYPE.STANDARD, USER_TYPE.LITE].includes(
    userType.userTypeId,
  )

  const onClick = (e) => {
    if (disableNeedUpgrade) {
      e.stopPropagation()
      EventEmitter.dispatch(SHOW_POPUP_UPGRADE)
    }
  }

  return (
    <div className="wh100" onClick={onClick}>
      {formatDateTime(
        rawData.score?.publicDateId,
        FORMAT.DATE,
        locale,
        timezone,
      )}
    </div>
  )
}
